import { trim } from 'lodash';
import store from 'store/index';
import queryString from 'query-string';
import { EventNames } from './new-theme-events';

export function getPlanAlertType(type) {
  let alertType = '';
  switch (type) {
    case 'trial_popup':
      alertType = 'normal_trial_popup';
      break;
    case 'limit_exhausted':
      alertType = 'limit_exhausted';
      break;
    case 'plan_expired':
      alertType = 'plan_expired';
      break;
    case 'limit_exhausted_10':
      alertType = 'limit_exhausted_10';
      break;
    case 'limit_exhausted_60':
      alertType = 'limit_exhausted_60';
      break;
    case 'limit_exhausted_90':
      alertType = 'limit_exhausted_90';
      break;
    case 'paid_plan_expired':
      alertType = 'paid_plan_expired';
      break;
    case 'paid_plan_expired_ninty':
      alertType = 'paid_plan_expired_ninty';
      break;
    default:
      alertType = '';
      break;
  }
  return alertType;
}

function checkTimeLimit(val) {
  let dayflag = true;
  if (val[0] === '-') return false;
  for (let i = 0; i < val.length - 4; i++) {
    if (val[i] === 'd' && val[i + 1] === 'a' && val[i + 2] === 'y') {
      let daysCount = parseInt(val.slice(0, i));
      dayflag = false;
      if (daysCount > 0) return false;
    }
  }
  if (dayflag) {
    for (let i = 0; i < val.length; i++) {
      if (val[i] === 'h') {
        let hoursCount = parseInt(val.slice(0, i));
        if (hoursCount > 10) return false;
      }
    }
  }
  return true;
}

function convertTimeTaken(seconds, milliseconds = false, showSeconds = false) {
  if (milliseconds) {
    if (seconds < 1000) {
      return `${seconds}ms`;
    }
    seconds = seconds / 1000;
  }
  if (seconds < 3600) {
    var a = Math.floor(seconds / 60); //minutes
    var b = seconds % 60; //seconds
    var days = 0;

    if (b !== 1) {
      // sec = "seconds";
    } else {
      // sec = "second";
    }

    if (a !== 1) {
      // min = "minutes";
    } else {
      // min = "minute";
    }

    if (!a) {
      return `${b.toFixed(0)}s`;
    }
    b = Math.round(b * 1000) / 1000;
    return `${a}m ${b.toFixed(0)}s`;
  } else {
    a = Math.floor(seconds / 3600); //hours
    var x = seconds % 3600;
    b = Math.floor(x / 60); //minutes
    var c = seconds % 60; //seconds

    if (c !== 1) {
      // sec = "seconds";
    } else {
      // sec = "second";
    }

    if (b !== 1) {
      // min = "minutes";
    } else {
      // min = "minute";
    }

    if (c !== 1) {
      // hour = "hours";
    } else {
      // hour = "hour";
    }

    if (Number.isNaN(a) || Number.isNaN(b)) {
      return false;
    }

    if (a > 24) {
      days = Math.floor(a / 24);
      a = a % 24;

      if (days === 1)
        return `${days}day ${a}h ${b}m${showSeconds ? `${c}s` : ''}`;
      return `${days}days ${a}h ${b}m${showSeconds ? ` ${c}s` : ''}`;
    }

    return `${a}h ${b}m${showSeconds ? ` ${c}s` : ''}`;
  }
}

function getAmpliteEventCommonProperties(eventPageType, stageTime) {
  let parsed = queryString.parse(window.location.search);
  let properties = {};
  let storeObj = store?.getState();
  let onboard = storeObj?.onboarding;
  let jobDetail = storeObj?.hypertestJobDetail;
  let isFirstTestAvailable = storeObj?.hypertestJobList?.isFirstTestAvailable;
  const tasksListData = storeObj?.hypertestTasksList?.listData;
  // current task
  let currentTask = tasksListData?.data?.filter((task) => {
    return task.id === parsed?.taskId;
  });
  if (currentTask?.length) {
    currentTask = currentTask[0];
  }
  // current stage
  //const stageListData = storeObj?.hypertestTaskLog?.hypertestTaskLog;

  // let currentStage = stageListData?.data?.data?.filter((stage) => {
  //   return parseInt(stage.order) === parseInt(parsed.order);
  // });

  // if (currentStage?.length) {
  //   currentStage = currentStage[0];
  // }
  // current job
  let currentJob = jobDetail?.hypertestJobDetail?.data?.data;
  let consumedTime = checkTimeLimit(
    convertTimeTaken(
      (new Date(currentJob?.end_time) - new Date(currentJob?.start_time)) / 1000
    )
  )
    ? convertTimeTaken(
        (new Date(currentJob?.end_time) - new Date(currentJob?.start_time)) /
          1000
      )
    : '-';
  let taskTime = convertTimeTaken(
    (new Date(currentTask?.end_time) - new Date(currentTask?.start_time)) / 1000
  );
  // let stageTime = convertTimeTaken(
  //   (new Date(currentStage?.updated_at) -
  //     new Date(currentStage?.started_at || currentStage?.created_at)) /
  //     1000
  // );

  switch (eventPageType) {
    case 'quickstart':
    case 'try an example':
    case 'generate yaml':
      properties['testing framework'] =
        onboard?.currentConfiguration?.frameworkType;
      properties['language'] =
        onboard?.currentConfiguration?.framework?.language;
      properties['framework'] = onboard?.currentConfiguration?.framework?.name;
      properties['isFirstTest'] = !isFirstTestAvailable;
      break;
    case 'task view':
      properties['step duration'] = stageTime;
      // properties['step status'] = currentStage?.status;
      properties['task id'] = currentTask?.id;
      properties['task duration'] = taskTime;
      properties['task status'] = currentTask?.status;
      properties['job id'] = currentJob?.id;
      properties['job duration'] = consumedTime;
      properties['job status'] = currentJob?.status;
      break;

    default: {
      if (currentJob?.id) {
        properties['job id'] = currentJob?.id;
        properties['job status'] = currentJob?.status;
      }

      if (currentTask?.id || parsed?.taskId) {
        properties['task id'] = currentTask?.id || parsed?.taskId;
        properties['task status'] = currentTask?.status || parsed?.taskStatus;

        if (parsed?.stageId) {
          properties['stage id'] = parsed?.stageId;
        }
      }
      break;
    }
  }
  return properties;
}

export function manageNegativeTime(time, taskLog = undefined) {
  if (time === '-' || time === '--') {
    return time;
  } else if (time.indexOf('-') >= 0 && taskLog) {
    sendAmplitudeEvents(EventNames.HYP_NEGATIVE_TASK_TIME, {
      updated_at: taskLog.updated_at,
      started_at: taskLog.started_at,
      name: taskLog.name,
    });
  }
  return time.replaceAll('-', '');
}

export const sendAmplitudeEvents = (eventName, data, pageType, stageTime) => {
  let eventPageType = eventName.split('-');
  if (eventPageType?.length) {
    eventPageType = trim(eventPageType[eventPageType.length - 1]);
  } else if (pageType) {
    eventPageType = pageType;
  }
  let commonProperties = getAmpliteEventCommonProperties(
    eventPageType,
    stageTime
  );

  if (window.amplitude) {
    window.amplitude.getInstance().logEvent(eventName, {
      ...data,
      ...commonProperties,
    });
  }
};
